import Search from "../../components/Search";

const SearchScreen = () => {
  return <Search />;
};

export default SearchScreen;
